// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xHJDp8EySI5IoW {
  display: flex;
  position: fixed;
  z-index: -1;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--ds-background-neutral, #091e420f);
}
.I98KBhkYgMfGoa {
  position: absolute;
  right: 66px;
  bottom: var(--ds-space-600, 48px);
  width: 351px;
  max-width: 30%;
  height: 332px;
}
@media only screen and (max-width: 750px) {
  .I98KBhkYgMfGoa {
    display: none;
  }
}
.TsC2Hw4_6Ck_Rp {
  position: absolute;
  z-index: -1;
  bottom: var(--ds-space-0, 0px);
  width: 100%;
}
@media only screen and (max-width: 750px) {
  .TsC2Hw4_6Ck_Rp {
    display: none;
  }
}
`, ""]);
// Exports
export var background = `xHJDp8EySI5IoW`;
export var people = `I98KBhkYgMfGoa`;
export var curve = `TsC2Hw4_6Ck_Rp`;
export default ___CSS_LOADER_EXPORT___;
